import React from 'react';
import classNames from 'classnames';
import Tooltip from 'components/pure/utils/Tooltip';

/**
 * OverflowTooltip component.
 * Render the provided children component.
 * If it overflows, also render a tooltip containing the provided text
 */
class OverflowTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
    };
  }

  alwaysShowTooltip() {
    return !!this.props.alwaysShowTooltip;
  }

  /**
   * Returns true if the child component is truncated by ellipsis
   */
  isChildTruncated() {
    return this.alwaysShowTooltip() || this._childRef.offsetWidth < this._childRef.scrollWidth;
  }

  /**
   * Handle mouse enter event on the child component
   * @param event
   */
  onMouseEnter = event => {
    // show tooltip if the children is truncated
    if (this.isChildTruncated()) {
      this.setState({showTooltip: true});
    }
  };

  /**
   * Handle mouse leave event on the child component
   * @param event
   */
  onMouseLeave = event => {
    // hide tooltip if it was visible
    if (this.state.showTooltip) {
      this.setState({showTooltip: false});
    }
  };

  /**
   * Return the provided child component updated with
   * props used for the tooltip logic
   **/
  renderChildren() {
    // this component expects a single child
    const child = React.Children.only(this.props.children);

    return React.cloneElement(child, {
      'data-tip': true,
      'data-for': this.props.divKey,
      ref: c => (this._childRef = c),
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
    });
  }

  render() {
    // Key that uniquely identifies the children to be rendered.
    // Needed by the Tooltip component.
    const divKey = this.props.divKey;
    const className = classNames('overflow-tooltip-container', this.props.className);

    // Render a div containing the provided child and its tooltip component
    return (
      <div className={className}>
        {this.renderChildren()}
        <Tooltip
          className="overflow-tooltip"
          id={divKey}
          effect="solid"
          place="top"
          class="overflow-tooltip"
          renderToLayer={true}
          active={this.state.showTooltip}
          parent={this._childRef}>
          <div>
            <span>{this.props.tooltipText}</span>
          </div>
        </Tooltip>
      </div>
    );
  }
}

export default OverflowTooltip;
